import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { map, Subscription } from "rxjs";
import { ApplicationService } from "src/app/services/application.service";
import { AuthService } from "src/app/services/auth.service";
import { MyUtils } from "src/app/services/my-utils.service";
import { environment } from "../../../environments/environment";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../snackbar/snackbar/snackbar.component";
import { SnackbarORComponent } from "../snackbar/snackbar-OR/snackbar-or/snackbar-or.component";
import { toStringList } from "../../interface/filters";
import { userHasEReputationMax } from "src/app/services/models/me-user";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();
  navButton: any[] = [];
  buttonValue: any;



  // eReputation = {
  //   "itemType": "Journey",
  //   "route": "",
  //   // "iconName": "assets/images/journey/e-reputation.png",
  //   "children": [],
  //   "displayName": "onlineReputation.Online Reputation",
  //   "disable": "",
  //   "name": "E-REPUTATION",
  //   "menuScope": [
  //     {
  //       "itemType": "Menu",
  //       "route": "",
  //       "iconName": "null",
  //       "children": [
  //         {
  //           "itemType": "MenuVoice",
  //           "route": "/home",
  //           "iconName": "dashboard",
  //           "children": [],
  //           "displayName": "Dashboard",
  //           "disable": "",
  //           "name": "DASHBOARD",
  //           "menuScope": [],
  //           "idItem": "E-REPUTATION#null#E-REPUTATION#DASHBOARD"
  //         },
  //         {
  //           "itemType": "SectionTab",
  //           "route": "",
  //           "iconName": "null",
  //           "children": [
  //             {
  //               "itemType": "MenuVoice",
  //               "route": "/e-reputation/analysis-E-Reputation",
  //               "iconName": "shopping_bag",
  //               "children": [],
  //               "displayName": "Purchased Subscriptions",
  //               "disable": "",
  //               "name": "Purchased Subscriptions",
  //               "menuScope": [],
  //               "idItem": "E-REPUTATION#null#E-REPUTATION#DASHBOARD"
  //             },
  //             {
  //               "itemType": "MenuVoice",
  //               "route": "/e-reputation/purchased-subscriptions",
  //               "iconName": "bar_chart",
  //               "children": [],
  //               "displayName": "E analysis",
  //               "disable": "",
  //               "name": "E analysis",
  //               "menuScope": [],
  //               "idItem": "E-REPUTATION#null#E-REPUTATION#DASHBOARD"
  //             },
  //           ],
  //           "displayName": "Online Reputation",
  //           "disable": "",
  //           "name": "SECTION-EREPUTATION",
  //           "menuScope": [],
  //           "idItem": "SHOPPER#null#SHOPPER#SECTION-SHOPPER"
  //         }

  //       ],
  //       "displayName": "E-Reputation",
  //       "disable": "",
  //       "name": "E-REPUTATION",
  //       "menuScope": [],

  //       "idItem": "E-REPUTATION#null#E-REPUTATION"
  //     }
  //   ],
  //   "idItem": "E-REPUTATION"
  // };


  buttonSelected: any;
  dashboardUrl = "/dashboard";
  isNotEreputation = false;
  loader = true;

  constructor(
    public utils: MyUtils,
    private router: Router,
    private applicationService: ApplicationService,
    private authService: AuthService,
    public snackbar: MatSnackBar,
  ) {
    this.buttonSelected = this.applicationService.navBarSelectValue;
    this.subscriptions.add(
      router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (this.isDashboardRoute(event.urlAfterRedirects)) {
            this.buttonSelected = null;
            this.applicationService.setNavBarValue(this.buttonSelected);
          }
        }
      })
    );
  }

  ngOnInit(): void {


    this.subscriptions.add(
      this.applicationService.openEReputationSubject.subscribe(data => {
        this.isNotEreputation = !data.eReputationManagement
      })
    );
    this.subscriptions.add(
      this.applicationService.openImporter.subscribe(data => {
        if (data)
          this.isNotEreputation = !data.importer
      })
    );
    this.subscriptions.add(
      this.authService.me$.subscribe((data) => {
        if (data) {
          this.loader = true;
          this.navButton = [];

        // ADD NEW ZERO TOLERANCE UNDER SALES
        // if (data.menu.find(item => item.name == "SALES")?.menuScope[0].children.find(item => item.name == "ZERO-TOLERANCE") == undefined) {
        //   data.menu.find(item => item.name == "SALES")?.menuScope[0].children.push({
        //     "itemType": "MenuVoice",
        //     "route": "/zero-tolerance",
        //     "iconName": "local_police",
        //     "children": [],
        //     "displayName": "Zero Tolerance",
        //     "disable": "",
        //     "name": "ZERO-TOLERANCE",
        //     "menuScope": [],
        //     "idItem": "SALES#null#SALES#SECTION-SALES#ZERO-TOLERANCE"
        //   });
        // }


          this.navButton = data.menu;

        const hasMaxAlready = this.navButton.some(btn => btn.name === 'E-REPUTATION-MAX');

        if (userHasEReputationMax(data) && !hasMaxAlready) {
          this.navButton.push({
            itemType: "Journey",
            route: "",
            displayName: "E-Reputation",
            disable: "",
            name: "E-REPUTATION-MAX",
            menuScope: [
              {
                itemType: "Menu",
                route: "",
                iconName: "",
                displayName: "Fake",
                name: "FAKE",
                children: []
              }
            ],
            idItem: "E-REPUTATION-MAX",
            children: [],
            iconName: "assets/images/journey/e-reputation.png"
          });

          }



          this.loader = false;
        }
      })
    );

    this.subscriptions.add(
      this.applicationService.navBarSelectSubject.subscribe((data) => {
        this.buttonSelected = data ? data.name : null;
      })
    );
    if (
      this.authService.meSelectValue?.menu.length === 1 &&
      !this.isDashboardRoute(this.router.url)
    ) {
      this.applicationService.setMenuItemValue("E-Reputation");
      this.buttonSelected = "E-REPUTATION"
      this.applicationService.setNavBarValue(this.navButton[0]);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private isDashboardRoute(url?: string): boolean {
    const path = (url || "").split(/[?#]/, 1)[0];
    return path === this.dashboardUrl || path.startsWith(`${this.dashboardUrl}/`);
  }

  checkDealerGroup() {
    if (this.utils.settingsPayloadValue.payload.network.dealer.length === 1 && this.utils.settingsPayloadValue.payload.network.dealer[0] !== '') {
      return true
    } else {
      return false
    }
  }

  // Online Reputation Max supports any number of selected dealers (roarmax's Network.dealers
  // is a list) — this only needs to reject the "nothing selected" placeholder state.
  hasSelectedDealers() {
    return toStringList(this.utils.settingsPayloadValue.payload.network.dealer).length > 0;
  }

  routerClick(button: any) {
    if (button.path != "") {
      this.buttonSelected = button.name;
      // Evaluate the dealer selection before setNavBarValue: switching touchpoint
      // synchronously publishes a transition payload with the dealer reset, so
      // checking again afterwards would reject a valid selection.
      const hasValidDealer = button.name === "E-REPUTATION" ? this.checkDealerGroup() : this.hasSelectedDealers();
      if (!["E-REPUTATION", "E-REPUTATION-MAX"].includes(button.name)) {
        this.applicationService.setNavBarValue(button);
      } else if (hasValidDealer) {
        this.applicationService.setNavBarValue(button);
      }
      switch (button.idItem) {
        case "SALES":
          {
            this.applicationService.setMenuItemValue("Sales analysis");
            this.router.navigate(["analysis/overview"]);
            this.snackbar.dismiss()
          }
          break;
        case "AFTERSALES":
          {
            this.applicationService.setMenuItemValue("After sales analysis");
            this.router.navigate(["analysis/overview"]);
            this.snackbar.dismiss()
          }
          break;

        case "SHOPPER":
          {
            this.applicationService.setMenuItemValue("Analysis");
            this.router.navigate(["analysis/overview"]);
            this.snackbar.dismiss()
          }
          break;

        case "E-REPUTATION-MAX":
          {
            if (this.authService.meSelectValue?.csiLevel !== 'DEALER_GROUP' &&
              this.authService.meSelectValue?.csiLevel !== 'DEALER' &&
              this.authService.meSelectValue?.csiLevel !== 'MARKET' &&
              this.authService.meSelectValue?.csiLevel !== 'REGION') {
              this.buttonSelected = null;
              this.applicationService.setNavBarValue(this.buttonSelected);
            } else {
              if (hasValidDealer) {
                this.applicationService.setMenuItemValue("E-Reputation");
                this.router.navigate(["e-reputation-max"]);
                this.snackbar.dismiss();
              } else {
                this.buttonSelected = ""
                this.applicationService.setMenuItemValue("Analysis");
                this.router.navigate([this.applicationService.previousCurrentRouteValue.current]);
                this.snackbar.openFromComponent(SnackbarORComponent, {
                  panelClass: "colorErrorMessage",
                });
              }
            }
          }
          break;

        case "E-REPUTATION":
          {
            if (this.authService.meSelectValue?.csiLevel !== 'DEALER_GROUP' && this.authService.meSelectValue?.csiLevel !== 'DEALER' && this.authService.meSelectValue?.csiLevel !== 'MARKET' && this.authService.meSelectValue?.csiLevel !== 'REGION') {
              this.buttonSelected = null;
              this.applicationService.setNavBarValue(this.buttonSelected);
            } else {
              if (hasValidDealer) {
                this.applicationService.setMenuItemValue("E-Reputation");
                this.router.navigate(["e-reputation"]);
                this.snackbar.dismiss();
              } else {
                this.buttonSelected = ""
                this.applicationService.setMenuItemValue("Analysis");
                this.router.navigate([this.applicationService.previousCurrentRouteValue.current]);
                this.snackbar.openFromComponent(SnackbarORComponent, {
                  panelClass: "colorErrorMessage",
                });
              }
            }
          }
          break;
        default:
          {
            this.applicationService.setMenuItemValue("Analysis");
            this.router.navigate(["analysis/overview"]);
            this.snackbar.dismiss()
          }
          break;
      }
      // this.router.navigate([button.path])
    }

  }
}
